import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import * as UserActions from '@store/user/user.actions';
import { AppState } from '@root/app-state.module';
import { Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { SearchType } from '@store/user/user.model';

@Component({
  selector: 'rlst-direct-link-login',
  templateUrl: './direct-link-login.component.html',
  styleUrls: ['./direct-link-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DirectLinkLoginComponent implements OnInit {

  constructor(private readonly store$: Store<AppState>, private readonly route: ActivatedRoute) { }

  ngOnInit() {
    const searchType: SearchType = this.route.snapshot.queryParams.searchType;
    this.store$.dispatch(new UserActions.DirectLinkLogin({ searchType }));
  }

}
